import { render, staticRenderFns } from "./TicketsModifyAccess.vue?vue&type=template&id=4c7ae7b8&"
import script from "./TicketsModifyAccess.vue?vue&type=script&lang=ts&"
export * from "./TicketsModifyAccess.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsModifyAccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCol,VContainer,VForm,VIcon,VRow,VSnackbar,VStepper,VStepperContent,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7ae7b8')) {
      api.createRecord('4c7ae7b8', component.options)
    } else {
      api.reload('4c7ae7b8', component.options)
    }
    module.hot.accept("./TicketsModifyAccess.vue?vue&type=template&id=4c7ae7b8&", function () {
      api.rerender('4c7ae7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/TicketsModifyAccess.vue"
export default component.exports